<template>
  <!-- Sekce pro si_rent (půjčení čipu) -->
  <v-col v-for="service in localSiRent" :key="service.id" cols="12" md="2">
    <h3>Půjčení čipu:</h3>
    <v-text-field
      v-model.number="service.price"
      label="Cena za půjčení čipu"
      type="number"
      min="0"
      suffix=",-Kč"
      density="comfortable"
      hint ="Bez uvedené ceny není půjčení čipu nabízeno. 0 = zadarmo"
      :error-messages="validationErrors.si_rent[service.id] || []"

    />
  </v-col>
 
  <v-row> 
    <v-col cols="12" md="2"><h2>Další služby:</h2></v-col>
    <v-col cols="12" md="10" class="d-flex flex-wrap gap-2">
      <v-row>
        <v-btn color="primary" class="w-100 w-md-auto order-2 order-md-1 mr-md-10 mt-1" @click="dialog = true">Přidat službu</v-btn>
        <v-btn color="green" @click="editService" :disabled="!isEditValid" class="w-100 mb-2 w-md-auto order-1 order-md-2 mt-1">Uložit služby</v-btn>
      </v-row>
    </v-col>
  </v-row>


  <v-row v-for="(variants, key, groupIndex) in groupedOtherServices" :key="key">
    <v-col cols="12" class="d-flex">
      <h3>Služba číslo {{ groupIndex + 1 }}</h3>
      <v-icon @click="openDeleteDialog(key, groupIndex)" color="red" size="large" class="ml-3">mdi-delete</v-icon>
    </v-col>

    <v-col
      v-for="service in variants"
      :key="service.id"
      cols="12"
      md="2"
    >
      <h4 class="mb-3">Varianta {{ service.variant }}</h4>
      <v-text-field
        v-model="service.name"
        label="Název"
        :rules="[v => !!v || 'Název je povinný']"
        maxlength="40"
        counter
        density="compact"
        :error-messages="validationErrors.edit[service.id]?.name || []"
        variant="outlined"
      />
      <v-text-field
        v-model="service.price"
        label="Cena"
        type="number"
        suffix=",-Kč"
        density="compact"
        :error-messages="validationErrors.edit[service.id]?.price || []"
        variant="outlined"
      />
      <v-text-field
        v-model="service.limit"
        label="Limit"
        type="number"
        density="compact"
        variant="outlined"
      />
      <v-text-field
        v-model="service.description"
        label="Popis"
        type="text"
        maxlength="130"
        counter
        density="compact"
        variant="outlined"
      />

    </v-col>

  </v-row>

  <!-- Dialog pro smazání služby -->
  <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>Odstranit službu</v-card-title>
        <v-card-text>
          Opravdu chceš smazat všechny celou <b>službu číslo {{ serviceGroupIndexToDelete + 1 }}</b>? <br>
        </v-card-text>
        <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
        <v-card-actions>
          <v-btn @click="dialogDelete = false">Zrušit</v-btn>
          <v-spacer />
          <v-btn color="red" @click="deleteService(serviceKeyToDelete)">Odstranit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  

  <!-- Dialog pro vytvoření nové služby s více variantami -->
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>Přidat službu</v-card-title>
      <v-card-text>
        <div v-for="(variant, index) in newServiceVariants" :key="index">
          <div class="d-flex align-center justify-space-between">
            <strong>Varianta #{{ index + 1 }}</strong>
            <v-icon
              v-if="newServiceVariants.length > 1"
              color="red"
              @click="removeVariant(index)"
            >mdi-delete</v-icon>
          </div>

          <v-text-field
            v-model="variant.name"
            label="Název"
            maxlength="40"
            counter
            :error-messages="validationErrors.newService[index]?.name || []"
            density="comfortable"
          />

          <v-text-field
            v-model="variant.price"
            label="Cena"
            type="number"
            suffix=",-Kč"
            :error-messages="validationErrors.newService[index]?.price || []"
            density="comfortable"
          />

          <v-text-field
            v-model="variant.limit"
            label="Limit"
            type="number"
            density="comfortable"
          />

          <v-text-field
            v-model="variant.description"
            label="Popis"
            type="text"
            maxlength="130"
            counter 
            density="comfortable"
          />

        </div>

        <v-btn variant="text" color="primary"  @click="addVariant">+ Přidat variantu</v-btn>

        <v-alert type="error" v-if="errorMessage" class="mt-4">
          {{ errorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="dialog = false">Zrušit</v-btn>
        <v-spacer />
        <v-btn color="green" @click="createService" :disabled="!isCreateValid">Vytvořit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


</template>

<script setup>
import { ref, watch, computed } from 'vue'
import apiClient from '/api.js';
import { useRoute } from 'vue-router'
import { useSnackbarStore } from '@/stores/snackbarStore'


const props = defineProps({
  siRent: {
    type: Array,
    default: () => []
  },
  otherService: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['submit'])

const route = useRoute()
const snackbar = useSnackbarStore()
const dialog = ref(false)

const dialogDelete = ref(false)
const serviceKeyToDelete = ref(null)
const serviceGroupIndexToDelete = ref(null)
const openDeleteDialog = (key, groupIndex) => {
  serviceKeyToDelete.value = key
  serviceGroupIndexToDelete.value = groupIndex
  dialogDelete.value = true
}

const newServiceVariants = ref([
  { name: '', price: null, limit: null }
])

const errorMessage = ref('')

const localOtherServices = ref([])
const localSiRent = ref([])

// props → lokální kopie
watch(
  () => props.otherService,
  (val) => {
    localOtherServices.value = val.map(s => ({ ...s }))
  },
  { immediate: true }
)

watch(
  () => props.siRent,
  (val) => {
    localSiRent.value = val.map(s => ({ ...s }))
  },
  { immediate: true }
)


// VALIDACE /////////////

const validationErrors = ref({
  newService: {
    name: [],
    price: []
  },
  edit: {},
  si_rent: {}
})

watch(localSiRent, (val) => {
  const errors = {}
  val.forEach(service => {
    if (service.price !== null && service.price !== '' && parseInt(service.price) < 0) {
      errors[service.id] = ['Cena nesmí být záporná']
    } else {
      errors[service.id] = []
    }
  })
  validationErrors.value.si_rent = errors
}, { deep: true, immediate: true })


watch(newServiceVariants, (val) => {
  validationErrors.value.newService = val.map(variant => ({
    name: !variant.name?.trim() ? ['Název je povinný'] : [],
    price:
      variant.price === null || variant.price === '' ? ['Cena je povinná']
      : []
  }))
}, { deep: true, immediate: true })


watch(localOtherServices, (val) => {
  const errors = {}
  val.forEach(service => {
    errors[service.id] = {
      name: !service.name?.trim() ? ['Název je povinný'] : [],
      price:
        service.price === null || service.price === '' ? ['Cena je povinná']
        : []
    }
  })
  validationErrors.value.edit = errors
}, { deep: true, immediate: true })


const isValidSiRent = computed(() => {
  return localSiRent.value.every(s =>
    s.price === null || s.price === '' || parseInt(s.price) >= 0
  )
})

const isEditValid = computed(() => {
  const servicesValid = Object.values(validationErrors.value.edit).every(err =>
    err.name.length === 0 && err.price.length === 0
  )
  return servicesValid && isValidSiRent.value
})

const isCreateValid = computed(() => {
  return validationErrors.value.newService.every(err =>
    err.name.length === 0 && err.price.length === 0
  )
})

// seskupení služeb na základě klíče
const groupedOtherServices = computed(() => {
  const grouped = {}
  for (const service of localOtherServices.value) {
    if (!grouped[service.key]) {
      grouped[service.key] = []
    }
    grouped[service.key].push(service)
  }
  // seřadit varianty uvnitř skupiny
  for (const key in grouped) {
    grouped[key].sort((a, b) => a.variant - b.variant)
  }
  return grouped
})


// Konec VALIDACE /////////////

const addVariant = () => {
  newServiceVariants.value.push({ name: '', price: null, limit: null })
}

const removeVariant = (index) => {
  newServiceVariants.value.splice(index, 1)
}

// Vytvoření nové služby
const createService = async () => {

  if (!isCreateValid.value) return

  try {
    const eventId = route.params.id
    const payload = newServiceVariants.value.map((variant, index) => ({
      name: variant.name,
      price: variant.price,
      limit: variant.limit,
      type: 'other',
      variant: index + 1,
      description: variant.description || ''
    }))

    await apiClient.post(`race_service/?event_id=${eventId}&create=true`, payload)

    dialog.value = false
    newServiceVariants.value = [{ name: '', price: null, limit: null }]
    errorMessage.value = ''

    snackbar.showSnackbar('Služby byly úspěšně vytvořeny.')
    emit('refresh')
  } catch (err) {
    if (err.response?.data?.error) {
      errorMessage.value = err.response.data.error
    } else {
      errorMessage.value = 'Chyba při vytváření služeb'
    }
    console.error(err)
  }
}


const editService = async () => {
  try {
    const payload = {
      si_rent: localSiRent.value.map(s => ({
        id: s.id,
        price: s.price ?? null
      })),
      other_service: localOtherServices.value.map(s => ({
        id: s.id,
        name: s.name,
        price: s.price,
        limit: s.limit,
        description: s.description,
        type: 'other',
        variant: s.variant || 1
      }))
    }

    await apiClient.put(`race_service/`, payload)

    errorMessage.value = ''
    snackbar.showSnackbar('Služby byly úspěšně aktualizovány.')
    emit('refresh')

  } catch (err) {
    if (err.response?.data?.error) {
      errorMessage.value = err.response.data.error
    } else {
      errorMessage.value = 'Chyba při ukládání služeb'
    }
    console.error(err)
  }
}

const deleteService = async () => {
  if (!serviceKeyToDelete.value) return

  try {
    await apiClient.delete(`race_service/?service_key=${serviceKeyToDelete.value}`)
    dialogDelete.value = false
    serviceKeyToDelete.value = null
    snackbar.showSnackbar('Služba byla úspěšně smazána.')
    emit('refresh')
  } catch (err) {
    if (err.response?.data?.error) {
      errorMessage.value = err.response.data.error
    } else {
      errorMessage.value = 'Nepodařilo se smazat službu'
    }
    console.error(err)
  }
}



</script>
